// // QuestionScroll.jsx
// import { useEffect } from 'react';
// import "./QuestionScroll.css";

// const QuestionScroll = (props) => {
//     let questions = props.questions;

//     useEffect(() => {
//         console.log('changed');
//         const element = document.getElementById(`q-${props.questionIndex}`);
//         if (element) {
//             console.log(element.offsetTop);
//             console.log(element.offsetParent);
//             const questionScroll = document.getElementById("question-scroll");
//             const questionRect = questionScroll.getBoundingClientRect();
//             const topScroll = element.offsetTop - (questionScroll.offsetHeight / 2) + (element.offsetHeight / 2);
//             console.log(topScroll);
//             console.log(questionScroll.scrollHeight);
//             questionScroll.scrollTo({ top: topScroll, left: 0, behavior: 'smooth' });
//         }
//     }, [props.questionIndex]);

//     return (
//         <div id="question-scroll" className="question-scroll">
//             {/* Render questions using props.questions */}
//             {questions.map((value, index) => (
//                 <div key={index} className={`question-piece ${index + 1 === props.questionIndex ? 'bold' : ''}`} id={`q-${index + 1}`}>
//                     {index + 1}. {value}
//                 </div>
//             ))}
//         </div>
//     );
// }

// export default QuestionScroll;
import React, { useEffect, useState } from 'react';
import "./QuestionScroll.css";

const QuestionScroll = (props) => {
    const [questions, setQuestions] = useState([]);

    const speak = (text, lang) => {
        const utterance = new SpeechSynthesisUtterance(text);
        utterance.text = text
        utterance.lang = lang;
        window.speechSynthesis.speak(utterance);
      };

      useEffect(() => {
        speak(questions[props.questionIndex-1], 'hi-IN');
      }, [props.questionIndex], questions.length);

    useEffect(() => {
        // Fetch questions from local storage when the component mounts
        const storedQuestions = localStorage.getItem('questions')!==null ? localStorage.getItem('questions').split(',') : [];
        setQuestions(storedQuestions);
    });

    useEffect(() => {
        // console.log('QuestionScroll: questions:', questions);
        // console.log('QuestionScroll: props.questionIndex:', props.questionIndex);

        const element = document.getElementById(`q-${props.questionIndex}`);
        if (element) {
            // console.log('QuestionScroll: element.offsetTop:', element.offsetTop);
            // console.log('QuestionScroll: element.offsetParent:', element.offsetParent);

            const questionScroll = document.getElementById("question-scroll");
            const questionRect = questionScroll.getBoundingClientRect();
            const topScroll = element.offsetTop - (questionScroll.offsetHeight / 2) + (element.offsetHeight / 2);

            // console.log('QuestionScroll: topScroll:', topScroll);
            // console.log('QuestionScroll: questionScroll.scrollHeight:', questionScroll.scrollHeight);

            questionScroll.scrollTo({ top: topScroll, left: 0, behavior: 'smooth' });
        }
    }, [props.questionIndex, questions]);

    return (
        <div id="question-scroll" className="question-scroll">
            {/* Render questions using state */}
            {questions.map((value, index) => (
                <div key={index} className={`question-piece ${index + 1 === props.questionIndex ? 'bold' : ''}`} id={`q-${index + 1}`}>
                    {index + 1}. {value}
                </div>
            ))}
        </div>
    );
}

export default QuestionScroll;

